module.exports = __webpack_public_path__ + "img/lowerabs-endo-mesomorph-male.865414af.svg";